/** 계정 버전 — prepare 응답의 apiVersion */
export const PORTONE_API_VERSION = {
  V1: 'V1',
  V2: 'V2',
} as const

export type TPortOneApiVersion = (typeof PORTONE_API_VERSION)[keyof typeof PORTONE_API_VERSION]

/** PortOne V2 payMethod — 서버 prepare 요청 기준값 */
export const PORTONE_PAY_METHOD = {
  CARD: 'CARD',
  VIRTUAL_ACCOUNT: 'VIRTUAL_ACCOUNT',
} as const

export type TPortOnePayMethod = (typeof PORTONE_PAY_METHOD)[keyof typeof PORTONE_PAY_METHOD]

export type TPortOneFormPayMethod = 'card' | 'vbank'

/** V2 payMethod → V1(iamport) pay_method */
export const PORTONE_V1_PAY_METHOD: Record<TPortOnePayMethod, TPortOneFormPayMethod> = {
  CARD: 'card',
  VIRTUAL_ACCOUNT: 'vbank',
}

/** 무통장 입금 기한 (일) */
export const PORTONE_VIRTUAL_ACCOUNT_DUE_DAYS = 7

export const IAMPORT_SDK_URL = 'https://cdn.iamport.kr/v1/iamport.js'

/** 모바일 redirect 복귀 시 PortOne이 붙이는 쿼리 키 (V2 + V1) */
export const PORTONE_REDIRECT_QUERY_KEYS = [
  'paymentId',
  'code',
  'message',
  'transactionType',
  'txId',
  'pgCode',
  'pgMessage',
  'imp_uid',
  'merchant_uid',
  'imp_success',
  'success',
  'error_code',
  'error_msg',
] as const
